import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DocumentMaster } from 'app/modules/document/models/document-master';
import { KvItem } from '../../core/models/kv-item';

@Component({
  selector: 'glenn-dale-results',
  template: `
  <div id="results">
    <div style="margin:10px 0;">
      <img src="/images/glenn_dale.jpg" alt="Glenn Dale Map" style="max-width:500px;display:block;margin:0 auto;"/>
    </div>
    <p-dataTable [value]="results">
      <p-column field="title" header="Click to Download" [style]="{ 'width': '13%'}" [sortable]="true">
        <ng-template pTemplate="body" let-r="rowData">
          <a (click)="downloadFile.emit({id: r.fileId, value: r.filename})" style="text-align:left;display:block;text-decoration:none;">{{r.title}}</a>
        </ng-template>
      </p-column>
      <p-column field="description" header="Document Title" [sortable]="true">
        <ng-template pTemplate="body" let-r="rowData">
          <span>{{r.description}}</span>
        </ng-template>
      </p-column>
      <p-column field="created" header="Date" [style]="{ 'width': '11%'}" [sortable]="true">
        <ng-template pTemplate="body" let-r="rowData">
          <span>{{r.created | date:'MM/yyyy'}}</span>
        </ng-template>
      </p-column>
    </p-dataTable>
  </div>
  <p-dialog [modal]="true" [showHeader]="false" [(visible)]="loading">
  <div style="text-align:center">Loading Data</div>
</p-dialog>
  `
})
export class GlennDaleResultsComponent {
  @Input() results: DocumentMaster[];
  @Input() loading = false;
  @Output() downloadFile: EventEmitter<KvItem> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/glenn-dale-results.ts